import React from "react";
import { Package } from "./api/package";

interface PackageCardProps {
  pkg: Package;
}

const PackageCard: React.FC<PackageCardProps> = ({ pkg }) => {
  return (
    <div
      style={{
        border: "1px solid #e0e0e0",
        borderRadius: "10px",
        overflow: "hidden",
        boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
        background: "white",
        cursor: "pointer",
        transition: "transform 0.2s, box-shadow 0.2s",
      }}
      onMouseEnter={(e) => {
        const target = e.currentTarget;
        target.style.transform = "translateY(-5px)";
        target.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
      }}
      onMouseLeave={(e) => {
        const target = e.currentTarget;
        target.style.transform = "translateY(0)";
        target.style.boxShadow = "0 4px 10px rgba(0,0,0,0.08)";
      }}
    >
      {pkg.image && (
        <img
          src={pkg.image}
          alt={pkg.name}
          style={{ width: "100%", height: "160px", objectFit: "cover" }}
        />
      )}

      <div style={{ padding: "1rem" }}>
        <h3 style={{ margin: "0 0 0.5rem 0", fontSize: "1.2rem", color: "#0077cc" }}>
          {pkg.name}
        </h3>
        <p style={{ margin: "0.3rem 0", fontWeight: 500 }}>🌙 {pkg.days} Nights</p>
        <p style={{ margin: "0.3rem 0", fontWeight: 600 }}>💰 From {pkg.price}</p>
        {pkg.description && (
          <p style={{ marginTop: "0.5rem", fontSize: "0.9rem", color: "#555" }}>
            {pkg.description}
          </p>
        )}
      </div>
    </div>
  );
};

export default PackageCard;
